export default "__VITE_ASSET__DH33jJwE__"